/**
 * Система расчёта
 */
export enum PayMethod {
    'AVANS' = 'avans',
    'CREDIT' = 'credit'
}

export namespace PayMethod {
    const labelMap = new Map<PayMethod, string>([
        [PayMethod.AVANS, 'Аванс'],
        [PayMethod.CREDIT, 'Кредит']
    ])

    export const getLabel = (payMethod: PayMethod): string => {
        return labelMap.get(payMethod) ?? ''
    }
}
